import {
  RbacAuthorization,
  RolePermissionMapping,
} from '@traton/devportal-rbac-common-lib';
import { roleMapping } from './roleMapping';

export class AgenticMarketplaceRbacAuthorization extends RbacAuthorization {
  protected getRoleMappings(): RolePermissionMapping {
    return roleMapping;
  }
}
